import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '@/store/convo/state'
import { RootState } from '@/store'
import convoUtils from '@/store/convo/actions/convo-utils'
import fetchStatements from '@/store/convo/actions/fetch-statements'
import { IStatement } from '@/model/statement';
import statementStore from '@/store/statement/statement-store';
import { IConvo } from '@/model/convo';

export default async function addConvoCommentStatement (context: BareActionContext<ConvoState, RootState>, payload: {convo: IConvo, statement: IStatement} ) {
  convoUtils.convoService.addStatement(payload.convo, payload.statement).then((result: any) => {
    statementStore.dispatchHideStatement(payload.statement)
    fetchStatements(context, payload.convo)
  })

  return
}
